import Swiper from 'swiper/bundle';

let TeaserLearn = {
	_init: () => {
		document.addEventListener('DOMContentLoaded', TeaserLearn._ready);
	},
	_ready: () => {
		const headlineSwiper = new Swiper('.teaserlearn-headlineslider', {
			loop: true,
			allowTouchMove: false,
			centeredSlides: true,
			slidesPerView: 'auto',
			loopAddBlankSlides: true,
			on: {
				click: (swiper, e) => {
					const { swiperSlideIndex } = e.target.dataset;
					learnSlider.slideToLoop(swiperSlideIndex);
					swiper.slideToLoop(swiperSlideIndex);
				}
			}
		});

		const learnSlider = new Swiper('.teaserlearn-learnslider', {
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			effect: "fade",
			fadeEffect: { crossFade: true },
			loopAddBlankSlides: true,
			keyboard: {
				enabled: true,
			},
			a11y: {
				enabled: true,
			},
			on: {
				init: (swiper) => {
					const slides = swiper.slides;

					// Set aria-label for each slide based on the title
					setTimeout(() => {
						slides.forEach((slide, index) => {
							const title = slide.querySelector('h3');
							if (title) {
								slide.setAttribute('aria-label', `${title.textContent} (slide ${index + 1} of ${slides.length})`);
							}
						});
					}, 0);

					for (let i = 1; i <= 3; i++) {
						let nextTitle = document.querySelector(`.swiper-slide-next .teaserlearn-learnslider-wrapper-slide-title${i}`);
						let prevTitle = swiper.slides[swiper.slides.length - 1].querySelector(`.teaserlearn-learnslider-wrapper-slide-title${i}`);
						
						prevTitle.classList.add('slide-right');
						nextTitle.classList.add('slide-left');
					}
				},
				slideNextTransitionStart: (swiper) => {
					for (let i = 1; i <= 3; i++) {
						let nextTitle = document.querySelector(`.swiper-slide-next .teaserlearn-learnslider-wrapper-slide-title${i}`);
						let prevTitle = document.querySelector(`.swiper-slide-prev .teaserlearn-learnslider-wrapper-slide-title${i}`);
						
						if (nextTitle.classList.contains('slide-right')) {
							nextTitle.classList.remove('slide-right');
						}
						
						if (nextTitle.classList.contains('slide-left')) {
							nextTitle.classList.remove('slide-left');
						}
						
						prevTitle.classList.add('slide-right');
						nextTitle.classList.add('slide-left');
					}
				},
				slidePrevTransitionStart: (swiper) => {
					let prevTitle;
					let nextTitle; 
					for (let i = 1; i <= 3; i++) {
						if (learnSlider.activeIndex === 0) {
							prevTitle = swiper.slides[swiper.slides.length - 1].querySelector(`.teaserlearn-learnslider-wrapper-slide-title${i}`);
						} else {
							prevTitle = document.querySelector(`.swiper-slide-prev .teaserlearn-learnslider-wrapper-slide-title${i}`);
						}
						
						nextTitle = document.querySelector(`.swiper-slide-next .teaserlearn-learnslider-wrapper-slide-title${i}`);

						if (prevTitle.classList.contains('slide-left')) {
							prevTitle.classList.remove('slide-left');
						}

						if (nextTitle.classList.contains('slide-right')) {
							nextTitle.classList.remove('slide-right');
						}
						
						nextTitle.classList.add('slide-left');
						prevTitle.classList.add('slide-right');
					}
				},
				slideChange: (swiper) => {
					headlineSwiper.slideToLoop(swiper.realIndex);
				}
			}
		});

	}
};

TeaserLearn._init();